import React from 'react';
import { UserProvider } from './contexts/UserContext';
import AuthenticatedApp from './components/AuthenticatedApp';

const App: React.FC = () => {
  return (
    <UserProvider>
      <AuthenticatedApp />
    </UserProvider>
  );
};

export default App;
